// apollo local state not working out for draggable component, so I need to use vuex
// may convert all local state to vueex later
import Vuex from 'vuex'
import dataUriToBuffer from 'data-uri-to-buffer';
import {groupedVecs} from '../shared/stripsettings.mjs'

const iSize = require('buffer-image-size');

const getDimensions = ({ dataUri }) => {
  if (!dataUri) return null
  const decoded = dataUriToBuffer(dataUri);
  return iSize(decoded)
};

const thumber = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => {
      reader.abort();
      reject(reader.error);
    };
    reader.onload = (f => e =>
      resolve(f.type.match('image.*') ? e.target.result : null))(file);
    reader.readAsDataURL(file);
  });
};

const zeroDate = () => new Date(0)

const thisYear = () => {
  const d = zeroDate()
  const now = new Date()
  d.setUTCFullYear(now.getUTCFullYear())
  return d
}

const nextMonth = (n = 1) => {
  const d = thisMonth()
  d.setUTCMonth(d.getUTCMonth() + n)
  return d
}

const nextDay = (n = 1) => {
  const d = thisDay()
  d.setUTCDate(d.getUTCDate() + n)
  return d
}

const thisMonth = () => {
  const d = thisYear()
  const now = new Date()
  d.setUTCMonth(now.getUTCMonth())
  return d
}

const thisDay = () => {
  const d = thisMonth()
  const now = new Date()
  d.setUTCDate(now.getUTCDate())
  return d
}

const shaveMs = (dt, n = 1) => {
  dt.setUTCMilliseconds(dt.getUTCMilliseconds() - n)
  return dt
}

const endOfDay = (n) => {
  return shaveMs(nextDay(n))
}

const endOfMonth = (n) => {
  return shaveMs(nextMonth(n))
}

const patchDate = (dt) => { 
  const d = zeroDate()
  d.setUTCFullYear(dt.getUTCFullYear())
  d.setUTCDate(dt.getUTCDate())
  d.setUTCMonth(dt.getUTCMonth())
  return d
}
export const patchStartOfDay = (dt) => patchDate(dt)

export const patchEndOfDay = (dt) => { 
  const d = patchDate(dt)
  d.setUTCDate(d.getUTCDate() +1 )
  return shaveMs(d)
}

export const vxMaps = {
  state: [
    'vecSelect',
    'vecs',
    'frames',
    'stateFrames',
    'storyFrames',
    'thumbnails',
    'vimeoFrames',
    'trash',
    'slideIndex',
    'frameStack',
    'frameStackPointer',
    'playSegment',
    'viSlider',
    'runMode',
    'thumbData',
    'vActiveSub',
    'cActiveSub',
    'pActiveSub',
    'bigActiveSection',
    'playerStats',
    'playerAction',
    'addedFilms',
    'viPeriodSelect',
    'viPeriodSelectStart',
    'viPeriodSelectEnd'
  ],
  getters: [
    'activeSlide',
    'redoable',
    'undoable',
    'confidence'
  ],
  mutations: [
    'setVecSelect',
    'setViPeriodSelect',
    'setViPeriodSelectStart',
    'setViPeriodSelectEnd',
    'setDefaultFrame',
    'replace',
    'setSlideIndex',
    'clearStack',
    'framesRedo',
    'framesUndo',
    'pushStack',
    'moveAll',
    'undup',
    'setPlaySegment',
    'setViSlider',
    'setRunMode',
    'setThumbData',
    'setThumb',
    'setVActiveSub',
    'setCActiveSub',
    'setPActiveSub',
    'setBigActiveSection',
    'setPlayerStats',
    'patchPlayerStats',
    'setPlayerAction',
    'addAddedFilm',
    'removeAddedFilm',
    'setAddedFilm',
    'resetContentCard'
  ],
  actions: [
    'actionThumbs',
    'fixViPeriodSelect',
    'actionViPeriodSelect'
  ]
}

// simplest deep copy cloneObject of plain objects is just this
const cloneObject = (ob) => ob ? JSON.parse(JSON.stringify(ob)) : ob

// compare - not ideal because obs may be sorted differently, but will do for this
const theSame = (a, b) => a && b ? JSON.stringify(a) === JSON.stringify(b) : a === b

// some shared functions in the store
// restore the state to a particular point
const frameStackRestore = (state, pointer) => {

  if (pointer < 0 || pointer >= state.frameStack.length) {
    console.log('outside stack range', pointer, this.frameStack)
  } else {
    const { data, slideIndex } = state.frameStack[pointer]
    const { vimeoFrames, thumbnails, frames, trash, storyFrames } = data
    state.frames = cloneObject(frames)
    state.storyFrames = cloneObject(storyFrames)
    state.thumbnails = cloneObject(thumbnails)
    state.vimeoFrames = cloneObject(vimeoFrames)
    state.slideIndex = slideIndex
    state.trash = cloneObject(trash)
    state.frameStackPointer = pointer
    return state.frameStack[pointer]
  }
}
// push latest values into
const pushStack = (state) => {
  const stackPack = slidePack(state)
  const currentStackPack = state.frameStackPointer > -1 ? state.frameStack[state.frameStackPointer] : null
  if (!currentStackPack || !theSame(currentStackPack.data, stackPack.data)) {
    // this one is a change, so push to the stack
    state.frameStackPointer++
    state.frameStack[state.frameStackPointer] = stackPack
    // need to dump any surplus redos
    if (state.frameStack.length > state.frameStackPointer + 1) {
      state.frameStack.splice(state.frameStackPointer + 1, state.frameStack.length - state.frameStackPointer)
    }
  }
}

// make a cloneObject of a consolidated object to push to the store
const slidePack = (state) => {
  return {
    data: {
      trash: cloneObject(state.trash),
      vimeoFrames: cloneObject(state.vimeoFrames),
      thumbnails: cloneObject(state.thumbnails),
      frames: cloneObject(state.frames),
      storyFrames: cloneObject(state.storyFrames)
    },
    slideIndex: state.slideIndex
  }
}

// a getter for the active slide
const activeSlide = (state) => {
  return state.slideIndex === -1 ? null : state.frames[state.slideIndex]
}

// the vueex store
export const vxStoreInit = () => {
  const store = new Vuex.Store({
    state: {
      vecs: Reflect.ownKeys(groupedVecs),
      vecSelect: Reflect.ownKeys(groupedVecs),
      viPeriodSelect: "All time",
      viPeriodSelectStart: null,
      viPeriodSelectEnd: null,
      addedFilms: [],
      frames: null,
      storyFrames: null,
      thumbnails: null,
      vimeoFrames: null,
      trash: null,
      slideIndex: -1,
      frameStack: [],
      frameStackPointer: -1,
      playSegment: null,
      viSlider: 66,
      runMode: null,
      thumbData: [],
      vActiveSub: null,
      bigActiveSection: null,
      // this is used to message the player an will contain actions such as
      //'play','pause' .. maybe others at later
      playerAction: null,
      // this is used by the player to signal what it's currently doing with the main(big) playing film
      playerStats: {
        filmID: null,
        currentTime: null,
        playing: false,
        filmMasterID: null,
        filmFileID: null,
        event: null,
        ended: false,
        floatRate: null
      }
    },
    actions: {
      actionViPeriodSelect({ commit, dispatch }, value) {
        commit('setViPeriodSelect', value)
        dispatch('fixViPeriodSelect')
      },
      fixViPeriodSelect({ commit, state }) {
        switch (state.viPeriodSelect) {
          case 'All time':
            commit('setViPeriodSelectStart', null)
            commit('setViPeriodSelectEnd', null)
            break

          case 'Custom':
            break

          case 'Today':
            commit('setViPeriodSelectStart', thisDay())
            commit('setViPeriodSelectEnd', endOfDay())
            break

          case 'Yesterday':
            commit('setViPeriodSelectStart', nextDay(-1))
            commit('setViPeriodSelectEnd', shaveMs(thisDay()))
            break

          case 'This month':
            commit('setViPeriodSelectStart', thisMonth())
            commit('setViPeriodSelectEnd', endOfMonth())
            break

          case 'Last month':
            commit('setViPeriodSelectStart', nextMonth(-1))
            commit('setViPeriodSelectEnd', shaveMs(thisMonth()))
            break

          default:
            throw 'unknown period' + state.viPeriodSelect
        }


      },
      actionThumbs({ commit }, { files }) {
        return Promise.all(
          files.map(file => thumber(file))
        ).then(r => {
          const thumbData = r.map((p, index) => ({
            thumb: p,
            file: files[index],
            index,
            retain: false,
            original: false,
            dimensions: getDimensions({ dataUri: p }),
            status: '',
            signedUrl: '',
            artworkID: null
          }));
          commit('setThumbData', thumbData);
        });
      }
    },
    getters: {
      confidence (state) {
        return state.viSlider / 100
      },
      redoable(state) {
        return state.frameStackPointer < state.frameStack.length - 1
      },
      // whether we can undo anything - used to show unframeStackdo arrow
      undoable(state) {
        return state.frameStackPointer > 0
      },
      activeSlide(state) {
        return activeSlide(state)
      },
      currentStackPack(state) {
        return state.frameStackPointer > -1 ? state.frameStack[state.frameStackPointer] : null
      },
      slidePack(state) {
        return slidePack(state);
      }
    },
    mutations: {
      setVecSelect (state, value) {
        state.vecSelect = value
      },
      setViPeriodSelect(state, value) {
        state.viPeriodSelect = value
      },
      setViPeriodSelectStart(state, value) {
        state.viPeriodSelectStart = value
      },
      setViPeriodSelectEnd(state, value) {
        state.viPeriodSelectEnd = value
      },
      setAddedFilm(state, value) {
        const index = state.addedFilms.findIndex(f => f.videoID === value.videoID)
        if (index === -1) throw 'couldnt find added film in store ' + value.videoID
        state.addedFilms.splice(index, 1, value)
      },
      removeAddedFilm(state, value) {
        state.addedFilms = state.addedFilms.filter(f => f.videoID !== value.videoID)
      },
      addAddedFilm(state, value) {
        state.addedFilms = [...state.addedFilms, value]
      },
      setRunMode(state, value) {
        state.runMode = value;
      },
      setPlayerStats(state, value) {
        state.playerStats = value;
      },
      patchPlayerStats(state, value = {}) {
        state.playerStats = {
          ...state.playerStats,
          ...value
        }
      },
      setPlayerAction(state, value) {
        state.playerAction = value
      },
      setThumbData(state, value) {
        state.thumbData = value;
      },
      setThumb(state, { property, value, index }) {
        state.thumbData[index][property] = value;
      },
      // move all items from one group to another
      moveAll(state, { from, to, clearFrom, clone }) {
        const fromData = state[from]
        const toData = state[to]
        // but only if theres something to do
        if (fromData && fromData.length) {
          // find those not in the target group
          const thumbs = fromData.filter(f => !toData.find(g => f.src === g.src))
          // update state with a cloneObject
          if (thumbs.length) {
            state[to] = toData.concat(cloneObject(thumbs))
          }
          if (clearFrom) {
            // possible that they should all be cleared
            state[from] = []
          } else if (!clone) {
            // if its not a cloneObject, then get rid of the source
            state[from] = fromData.filter(f => !state[to].find(g => g.src === f.src))
          }
        }
        // finally push result to stack - will only register if theres a change
        pushStack(state)
      },
      setVActiveSub(state, value) {
        state.vActiveSub = value
      },
      setBigActiveSection(state, value) {
        state.bigActiveSection = value
      },
      setPlaySegment(state, value) {
        state.playSegment = value
      },
      setViSlider(state, value) {
        state.viSlider = value
      },
      framesRedo(state) {
        // a redo means go forward one from now and do it again
        frameStackRestore(state, state.frameStackPointer + 1)
      },
      framesUndo(state) {
        // an undo means go back one - not popping so that redos are supported too
        frameStackRestore(state, state.frameStackPointer - 1)
      },
      setDefaultFrame(state) {
        state.frames.forEach(f => {
          f.defaultPosterFrame = false
        })
        if (state.slideIndex !== -1) {
          state.frames[state.slideIndex].defaultPosterFrame = true
        }
      },
      undup(state) {
        // there are various reasons for endin gup with duplicates including the return of a cloned
        // item - this would apply to trash and thumbnails only, but in case of any faiures just do them all
        const dupList = ['trash', 'thumbnails', 'frames', 'storyFrames', 'vimeoFrames']
        dupList.forEach(name => {
          state[name] = state[name] ? state[name].filter((f, i, a) => a.findIndex(g => g.src === f.src) === i)
            : state[name]
        })
        const checkList = ['storyFrames', 'frames']
        // if an item is not longer in thumbnails, it cant be a frame either
        checkList.forEach(name => {
          state[name] = state[name] ? state[name].filter(f => state.thumbnails.find(g => g.src === f.src))
            : state[name]
        })
        // and there must be one default
        if (state.frames && state.frames.length && !state.frames.find(f => f.defaultPosterFrame)) {
          state.frames[0].defaultPosterFrame = true
        }
      },
      replace(state, { name, value }) {
        state[name] = value ? [...value] : null
      },
      frames(state, value) {
        state[frames] = value ? [...value] : null
      },
      setSlideIndex(state, value) {
        state.slideIndex = value
      },
      clearStack(state) {
        state.frameStack = []
        state.frameStackPointer = -1
      },
      frameStackRestore(state, pointer) {
        return frameStackRestore(state, pointer)
      },
      pushStack(state) {
        pushStack(state)
      }
    }
  })
  return store
}
